import React from 'react';
import { Map, ShieldCheck, QrCode, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';

// Step number + icon are structural; title/body are localized via keys.
const STEPS = [
  { num: '01', Icon: Map, titleKey: 'home_step1_title', bodyKey: 'home_step1_body' },
  { num: '02', Icon: ShieldCheck, titleKey: 'home_step2_title', bodyKey: 'home_step2_body' },
  { num: '03', Icon: QrCode, titleKey: 'home_step3_title', bodyKey: 'home_step3_body' },
  { num: '04', Icon: Star, titleKey: 'home_step4_title', bodyKey: 'home_step4_body' },
];

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  return (
  <section
    id="how-it-works"
    className="-mx-4 px-4 py-16 bg-brand-primary/10 rounded-3xl scroll-mt-20"
  >
    <div className="space-y-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:items-end">
        <div className="space-y-4">
          <p className="font-heading font-bold text-sm tracking-[0.25em] text-brand-accent uppercase">
            {t('home_how_it_works')}
          </p>
          <h2 className="font-display text-warm-800 text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            {t('home_hiw_title_1')}
            <br />
            {t('home_hiw_title_2')}
          </h2>
        </div>
        <p className="text-warm-500 text-lg leading-relaxed lg:max-w-md lg:justify-self-end">
          {t('home_hiw_intro')}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map(({ num, Icon, titleKey, bodyKey }, i) => (
          <Reveal key={num} delay={i * 80}>
            <div className="bg-white rounded-2xl p-6 space-y-5 border border-warm-200/60 h-full">
              <div className="flex items-start justify-between">
                <span className="font-display text-4xl text-warm-300">{num}</span>
                <div className="w-11 h-11 bg-brand-primary/20 rounded-xl flex items-center justify-center">
                  <Icon className="w-5 h-5 text-brand-secondary" />
                </div>
              </div>
              <div className="space-y-2">
                <h3 className="font-display text-2xl text-warm-800">{t(titleKey)}</h3>
                <p className="text-warm-500 leading-relaxed">{t(bodyKey)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};

export default HowItWorks;
